import { ScheduleTimeDto, ScheduleTimeResponseDto } from '../api'

export class ScheduleTime implements ScheduleTimeResponseDto {
  name: string;
  email: string;
  ccEmail: string;
  enable: boolean;
  minute: number;
  hour: number;
  frequency: number;
  timestamp: number;
  periodCovered: string;
  next: number;
  time: string;

  compareDifferences (schedule: ScheduleTimeDto) {
    const keysToCompare = ['email', 'ccEmail', 'enable', 'minute', 'hour', 'frequency']
    return keysToCompare.some(key => this[key] !== schedule[key])
  }

  static cloneSchedule (schedule: ScheduleTimeResponseDto) {
    const newSchedule = new ScheduleTime()
    Object.keys(schedule).forEach(key => {
      newSchedule[key] = schedule[key]
    })
    return newSchedule
  }
}
